module.exports = __webpack_public_path__ + "static/media/white-label-trophy-icon.9d72d525.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white-label-trophy-icon.svg
// module id = 780
// module chunks = 0